import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import { createEntryApprovalRequest } from '../../api/api';
import { toast } from 'react-toastify';
import { PaymentOptions } from './PaymentOptions';
import { currentYear } from '../../utils/date';

function RebuyModal(props) {
    const [amount, setAmount] = useState(5);

    const handleSubmit = (event) => {
        event.preventDefault();
        createEntryApprovalRequest(currentYear(), amount * 1, 0, "Rebuy approval request").then((user) => {
            props.setShow(false);
            props.setUser(user);
            toast.success("Rebuy request submitted.");
        });
    };

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton={true}>
                <Modal.Title>Submit Rebuy Request</Modal.Title>
            </Modal.Header>

            <Form>
                <Modal.Body>
                    <p>Request approval for buying extra weekly entries.</p>
                    <p>Remember, if the previous week (or multiple weeks) rolled over and you're submitting
                        extra weekly entries that exceed the number of entries you had in the rollover
                        weeks you have to pay for this week and each week that rolled over.
                    </p>
                    <Form.Group className="mb-3" controlId="numberOfEntries">
                        <Form.Label>Amount of Money Requested</Form.Label>
                        <Form.Select onChange={(e) => setAmount(parseInt(e.target.value, 10))} value={amount}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value="25">25</option>
                            <option value="30">30</option>
                            <option value="35">35</option>
                            <option value="40">40</option>
                            <option value="45">45</option>
                            <option value="50">50</option>
                        </Form.Select>
                    </Form.Group>

                    <p>Send <strong>${amount}</strong> to Phil via:</p>
                    <PaymentOptions />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => props.setShow(false)}>Cancel</Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>Request Rebuy Approval</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default RebuyModal;